import { render } from "./RxMenu.vue?vue&type=template&id=24ad8150&scoped=true"
import script from "./RxMenu.vue?vue&type=script&lang=js"
export * from "./RxMenu.vue?vue&type=script&lang=js"

import "./RxMenu.vue?vue&type=style&index=0&id=24ad8150&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ad8150"]])

export default __exports__